import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog, openDialog } from '../../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../../features/snackbar';
import { addJob,previewJob } from '../../../features/job';
import JobForm from '../JobForm';
import JobPreviewDialog from './JobPreviewDialog';
import { validateProjectJob } from '../../../validator/project';
import { hasErrors } from '../../../common';

const DIALOG_ID = "newJob"
const DIALOG_WIDTH = "md"

function NewJobDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const project = useSelector(state => state.project.single);
    const show = !!useSelector((state) => state.dialog[DIALOG_ID])
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({});

    const preview = e => {
        e && e.preventDefault() && e.stopPropagation();
        dispatch(previewJob(form))
        .then(() => {
            dispatch(openDialog("jobPreview"));
        })
        .catch(err => {
            dispatch(enqueueErrorSnack("Error previewing job: " + err.message));
        });
    }

    const save = e => {
        e && e.preventDefault() && e.stopPropagation();
        console.log(form);

        const validationErrors = validateProjectJob(form);
        if(hasErrors(validationErrors)){
            setErrors(validationErrors);
            return;
        }

        if(!form.active){
            form.active = 0;
        }

        const payload = {...form};
        if(payload.type === 'nfo'){
            const opts = payload.options && typeof payload.options === 'object' ? {...payload.options} : {};
            if(Array.isArray(opts.language_codes) && opts.language_codes.length === 0){
                delete opts.language_codes;
            }
            payload.options = opts;
        }

        setLoading(true);
        dispatch(addJob({
            project,
            job: payload
        }))
        .then(r => {
            dispatch(closeDialog(DIALOG_ID));
            dispatch(enqueueSuccessSnack("Job saved"))    
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }

    const canPreview = () => {
        if (!form.type) return false;
        
        // For web search types, check for 'search' property
        if (form.type === 'wh') {
            return !!form.search;
        }
        
        // For other types, check for 'searchJson' property
        return !!form.searchJson && Object.keys(form.searchJson).length > 0;
    }

    useEffect(() => {
        setForm({});
    }, [show])

    return <>
        <JobPreviewDialog />
        <Dialog
            open={!!show}
            onClose={onClose}
            fullWidth
            maxWidth={DIALOG_WIDTH}
        >
        <form onSubmit={save}>
            <DialogTitle>
                Create job
            </DialogTitle>
            <DialogContent dividers={false}>

                <Box pr={3}>
                    <JobForm form={form} onChange={setForm} errors={errors} />
                </Box> 
                
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
                {loading && <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, right: 0 }} />}
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button id="previewButton" variant="contained" color="secondary" disabled={!canPreview() || loading} onClick={preview}>
                        Preview Job
                    </Button>
                    <Button variant="contained" color="secondary" type="submit" disabled={loading}>
                        Create Job
                    </Button>
                </Box>
            </DialogActions>
        </form>
    </Dialog>
    </>
}

export default NewJobDialog;